/**
 * 聊天相关的React Hook
 * 提供会话管理和消息发送的功能
 */

import { chatService } from '../services/chat.service'

/**
 * 新的聊天Hook - 支持动态智能体
 * @param sessionId 会话ID
 * @param agentId 智能体ID（可选，默认使用固定ID）
 * @param agentSetting 智能体设定/系统提示词（可选）
 * @param searchConfig 搜索配置（可选）
 * @param callbacks 回调函数
 * @returns 聊天相关的操作方法
 */
export const useNewChat = (
  sessionId: string,
  agentId?: string,
  agentSetting?: string,
  searchConfig?: any,
  callbacks?: {
    onMessage?: (event: any) => void
    onError?: (error: Event) => void
    onDone?: () => void
  }
) => {
  /**
   * 发送消息到新的Python服务
   * @param content 用户输入内容
   * @returns Promise<void>
   */
  const sendMessage = async (content: string): Promise<void> => {
    // 使用动态的聊天参数
    const chatRequest = {
      session_id: sessionId,
      agent_id: agentId || '', // 使用传入的智能体ID或默认ID
      content: content,
      system_prompt: agentSetting || '',
      model: {
        model: 'qwen-plus',
        base_url:
          'https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions',
        think: true,
      },
      force_rag: true,
      search_config: searchConfig || null,
    }

    // 调用新的API服务
    console.log('发送消息到新服务:', chatRequest)

    try {
      await chatService.chatWithAgent(chatRequest, {
        onMessage:
          callbacks?.onMessage ||
          ((event) => {
            console.log('收到SSE消息:', event)
          }),
        onError:
          callbacks?.onError ||
          ((error) => {
            console.error('SSE连接错误:', error)
          }),
        onDone:
          callbacks?.onDone ||
          (() => {
            console.log('SSE连接完成')
          }),
        timeout: 30000, // 30秒超时
      })
    } catch (error) {
      console.error('调用chatWithAgent失败:', error)
      throw error
    }
  }

  return {
    sendMessage,
  }
}
